<!-- Add client button -->
<button *ngIf="!isAddingNewClient && isAddButtonVisible" class="button button_icon-only button_theme_main add-button" (click)="addNewClient()">
    <i class="fa-regular fa-user-plus"></i>
</button>

<!-- Client table -->
<p-dataView
    *ngIf="!isAddingNewClient"
    #dataView
    class="dataview"
    [ngClass]="{ 'dataview_without-content': state != 'loaded' }"
    [value]="customers"
    filterBy="fl,pelephone,comments"
    layout="grid"
    [paginator]="true"
    [rows]="rows"
    [alwaysShowPaginator]="false"
    paginatorPosition="bottom"
    (onPage)="onPageChange()"
    [lazy]="true"
    [totalRecords]="totalRecords"
    (onLazyLoad)="loadCustomersLazyAll($event)"
>
    <p-header>
        <!-- Client filter -->
        <div class="dataview__header">
            <div class="input-wrapper input-wrapper_high" [ngClass]="{ 'input-wrapper_disabled': isFiltersDisabled() }">
                <input
                    class="input"
                    [(ngModel)]="filterValue"
                    type="search"
                    inputmode="search"
                    placeholder="חפש לפי שם, טלפון או הערה"
                    [disabled]="isFiltersDisabled()"
                    autocomplete="off"
                    (input)="filterByInput()"
                />
            </div>
        </div>
    </p-header>

    <!-- Client card -->
    <ng-template let-customer pTemplate="gridItem">
        <div class="dataview__card" (click)="getCustomer(customer.customerId)">
            <div class="card__header">
                <div class="card__client">
                    <span class="card__name">
                        {{ customer.fl }}
                    </span>

                    <span *ngIf="customer.age > 0 || customer.sex == 2 || customer.sex == 3" class="card__info">
                        (<span *ngIf="customer.age > 0">{{ customer.age }}</span>
                        <!-- <span *ngIf="customer.sex == 1">לא מוגדר</span> -->
                        <span *ngIf="customer.age > 0 && (customer.sex == 2 || customer.sex == 3)">, </span>
                        <span *ngIf="customer.sex == 2">אישה</span>
                        <span *ngIf="customer.sex == 3">גבר</span>)
                    </span>
                </div>

                <span class="card__phone">
                    {{ customer.pelephone }}
                </span>
            </div>

            <div class="card__content">
                <div class="card__details">
                    <div *ngIf="customer.isBirthDay || customer.isDebt" class="card__badges">
                        <div *ngIf="customer.isBirthDay" class="card__badge badge_birthday">
                            <i class="badge__icon fa-regular fa-cake-candles"></i>
                        </div>

                        <div *ngIf="customer.isDebt" class="card__badge badge_debt">
                            <i class="badge__icon fa-duotone fa-coins"></i>
                        </div>
                    </div>

                    <p *ngIf="customer.comments" class="card__text custom-scrollbar">{{ customer.comments }}</p>
                    <p *ngIf="!customer.comments" class="card__text card__text_empty">אין עדיין הערות בכרטיס הלקוח/ה</p>
                </div>

                <div class="card__image-wrapper">
                    <span class="card__vip fa-solid fa-heart" [ngClass]="{ card__vip_active: customer.isVip }"></span>
                    <img class="card__image" [src]="getClientImageSrc(customer)" (error)="clearImagePath(customer.customerId)" alt="Client picture" />
                </div>
            </div>
        </div>
    </ng-template>
</p-dataView>

<!-- Loading status -->
<div *ngIf="state == 'loading'" class="dataview__loader-wrapper">
    <span class="dataview__loader-text">טוען מאגר לקוחות...</span>
    <span class="dataview__loader"></span>
</div>

<!-- No clients status -->
<div *ngIf="state == 'noclients' && !isAddingNewClient" class="dataview__empty-wrapper">
    <h3 class="dataview__empty-title">אין עדיין לקוחות במאגר</h3>
    <span class="dataview__empty-text">
        להוספת לקוחות למאגר (ולא רק לתור ביומן), היכנסו בתפריט הראשי לאזור ה”לקוחות” ולחצו על ה
        <span class="dataview__empty-plus">+</span>
    </span>
    <span class="dataview__empty-image"></span>
</div>

<!-- No filter result status -->
<div *ngIf="state == 'noresults' && !isAddingNewClient" class="dataview__empty-wrapper dataview__empty-wrapper_no-result">
    <h3 class="dataview__empty-title">
        לא מצאנו תוצאות לחיפוש <span class="dataview__empty-filter">{{ filterValue }}</span>
    </h3>
    <span class="dataview__empty-text">שימו לב, ניתן לחפש לפי שם, טלפון או הערה.</span>
    <span class="dataview__empty-image"></span>
</div>

<div *ngIf="(state == 'noclients' || state == 'noresults') && isAddButtonVisible && !isAddingNewClient" class="dataview__helper">
    <span class="dataview__helper-text"> בכדי להוסיף לקוח/ה חדש לתור נא לחצו על כפתור הפלוס </span>
    <span class="dataview__helper-arrow"></span>
</div>

<!-- Add new client form -->
<div *ngIf="isAddingNewClient" class="new-client">
    <section class="new-client__card">
        <form #form="ngForm" class="new-client__form">
            <div
                class="form__item input-wrapper input-wrapper_with-label"
                [ngClass]="{
                    'input-wrapper_error': isInputInvalid(firstName),
                    'input-wrapper_with-details': isInputInvalid(firstName)
                }"
            >
                <span class="input-label">שם פרטי</span>
                <input
                    class="input"
                    [(ngModel)]="firstNameValue"
                    name="firstName"
                    #firstName="ngModel"
                    type="text"
                    required
                    maxlength="30"
                    pattern="^(?!\s*$).+"
                    autocomplete="off"
                />
                <span *ngIf="isInputInvalid(firstName) && (firstName.errors.required || firstName.errors.pattern)" class="input-details"
                    >חובה להזין שם לקוח</span
                >
            </div>

            <div class="form__item input-wrapper input-wrapper_with-label">
                <span class="input-label">שם משפחה</span>
                <input class="input" [(ngModel)]="lastNameValue" name="lastName" type="text" maxlength="30" autocomplete="off" />
            </div>

            <div
                class="form__item input-wrapper input-wrapper_with-label"
                [ngClass]="{ 'input-wrapper_error': isInputInvalid(pelephone), 'input-wrapper_with-details': isInputInvalid(pelephone) }"
            >
                <span class="input-label">מס׳ טלפון</span>
                <input
                    class="input form__input_type_phone"
                    [(ngModel)]="pelephoneValue"
                    name="pelephone"
                    #pelephone="ngModel"
                    type="tel"
                    inputmode="tel"
                    maxlength="10"
                    pattern="05[0-9]{8}"
                    autocomplete="off"
                    (input)="onPhoneInput($event.target)"
                />
                <span *ngIf="isInputInvalid(pelephone) && pelephone.errors.pattern" class="input-details">מספר טלפון לא תקין</span>
            </div>

            <div class="form__item input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select">
                <span class="input-label">מין</span>
                <select class="input" [(ngModel)]="sex" name="sex">
                    <option *ngFor="let gender of sexData" [value]="gender.id">{{ gender.name }}</option>
                </select>
            </div>

            <label class="form__item switch-label switch-label_size_small">
                הוספת הלקוח/ה למאגר הלקוחות
                <input class="switch" [(ngModel)]="appDataTemp.forceCreateCustomer" name="forceCreateCustomer" type="checkbox" />
                <span class="custom-switch"></span>
            </label>
        </form>

        <div class="card__footer">
            <button class="footer__button footer__save-button button button_size_small button_theme_main" (click)="submitForm(form)">המשך</button>
            <button class="footer__button footer__exit-button button button_size_small button_theme_gray-line" (click)="exitAdding()">בטל</button>
        </div>
    </section>

    <span class="new-client__image"></span>
</div>
